export const trim = (value?: string | null) => (typeof value === "string" ? value.trim() : value)
